import store from '../Redux/Store/store';
import clearName from './clearNames';

/**
 * Esta funcion nos ayuda para crear nuestro json para el atlas packer
 */
const createAtlasJSON = (scale: number) => {
    const MaxRectData = store.getState().maxrectAtlas;
    const atlasJSON = {
        frames: MaxRectData.map((sprite_data) => {
            return {
                filename: clearName(sprite_data.data.name),
                frame: {
                    w: sprite_data.width * scale,
                    h: sprite_data.height * scale,
                    x: sprite_data.x * scale,
                    y: sprite_data.y * scale,
                },
                anchor: {
                    x: sprite_data.data.origin.x,
                    y: sprite_data.data.origin.y,
                },
            };
        }),
        meta: {
            description: 'Atlas generado con Atlas Packer Gamma V2',
            web: 'https://gammafp.github.io/atlas-packer-phaser/',
        },
    };
    return JSON.stringify(atlasJSON, null, '    ');
};

export default createAtlasJSON;
